// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"d43b716e","292":"79411964","367":"5fff620d","418":"9cc7d584","938":"b5d9ba99"}[chunkId] + ".chunk.css";
};